import script from "./PropertyDetailsSideCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailsSideCards.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailsSideCards.vue?vue&type=style&index=0&id=54fa079c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54fa079c"]])

export default __exports__